<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div [formGroup]="parentFormGroup">
  <div class="input-group">
    <ng-container *ngIf="isInModal; else outsideModal">
    <ng-select
      [items]="data | async"
      bindLabel="name"
      bindValue="id"
      [loading]="loader"
      (change)="handleChange($event)"
      [formControlName]="passFormControlName"
      class="ng-select"
      [typeahead]="input$"
    >
      <ng-template ng-typetosearch-tmp>
        <div class="ng-option disabled">
          {{ 'START_TYPING' | translate }}
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        <div class="venue-select-option-wrapper">
          <div class="venue-name">{{ item.name }}</div>
          <div class="venue-city" *ngIf="item.city">{{ item.city.name }},</div>
          <div class="venue-country" *ngIf="item.city?.country">{{ item.city.country.name }}</div>
        </div>
      </ng-template>

      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
          <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
          <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
            <i class="fal fa-plus"></i> {{ 'VENUE_SELECT.ADD' | translate }}
          </button>
        </div>
      </ng-template>
    </ng-select>
    </ng-container>

    <ng-template #outsideModal>
      <ng-select
        [items]="data | async"
        appendTo="body"
        bindLabel="name"
        bindValue="id"
        [loading]="loader"
        (change)="handleChange($event)"
        [formControlName]="passFormControlName"
        class="ng-select"
        [typeahead]="input$"
      >
        <ng-template ng-typetosearch-tmp>
          <div class="ng-option disabled">
            {{ 'START_TYPING' | translate }}
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
          <div class="venue-select-option-wrapper">
            <div class="venue-name">{{ item.name }}</div>
            <div class="venue-city" *ngIf="item.city">{{ item.city.name }},</div>
            <div class="venue-country" *ngIf="item.city?.country">{{ item.city.country.name }}</div>
          </div>
        </ng-template>

        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
          <div class="ng-option disabled">
            <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
            <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
              <i class="fal fa-plus"></i> {{ 'VENUE_SELECT.ADD' | translate }}
            </button>
          </div>
        </ng-template>
      </ng-select>
    </ng-template>

    <div class="input-group-append" *ngIf="distance && distance['lat'] && distance['long'] && selected">
      <a
        href="http://maps.google.com/maps?saddr={{ distance['lat'] }},{{ distance['long'] }}&daddr={{ selected.lat }},{{
          selected.long
        }}"
        target="_blank"
        class="input-group-text btn btn-primary"
        [ngbTooltip]="'VENUE_SELECT.DIRECTION' | translate"
      >
        <i class="fal fa-map-signs"></i>
      </a>
    </div>
  </div>
</div>
